
import React, {useState} from 'react';
import Hashtag from "./Hashtag";
import './styles/chronic.css';

const chronik = [
    {"ts": "1861", "description":"Gründung durch Ernst Bräuner"},
    {"ts": "1861 - 1873", "description":"Chorleiter Kanton Ehrich"},   
    {"ts":"1874 - 1882", "description": "Chorleiter Kantor Becker"},
    {"ts":"1883 - 1886", "description": "Chorleiter Lehrer Franz Knape"},
    {"ts":"1889 - 1906", "description": "Chorleiter Lehrer Edmund Engelhardt"},
    {"ts":"1906 - 1907", "description": "Chorleiter Lehrer Vorrath"},
    {"ts":"1907 - 1914", "description": "Chorleiter Lehrer Wittkopf"},
    {"ts":"1914 - 1918", "description": "1.Weltkrieg, ruhendes Vereinsleben"},
    {"ts":"1919 - 1924", "description": "Chorleiter Lehrer Wieland"},
    {"ts":"1925 - 1927", "description": "Chorleiter Lehrer Kläber"},
    {"ts":"1927 - 1931", "description": "Chorleiter Schneider Kutz"},
    {"ts":"1931 - 1940", "description": "Chorleiter Kantor Kurt Schenk"},
    {"ts":"1940 - 1945", "description": "2.Weltkrieg, ruhendes Vereinsleben"},
    {"ts":"1945 - 1947", "description": "Verbot aller ehemaligen dt. Vereine durch die Militäradministration"},
    {"ts":"1947 - 1968", "description": "Chorleiter Kantor Kurt Schenk"},
    {"ts":"1968 - 1982", "description": "Chorleiter Musikpädagoge & Lehrer Siegfried Hühnermund"},
    {"ts":"1983 - 1986", "description": "Chorleiter Musikpädagoge Dietmar Wegener"},
    {"ts":"1986 - 1999", "description": "Chorleiter Fleischermeister Otto Riedel"},
    {"ts":"1999 - 2013", "description": "Chorleiter Musiklehrer Horst Nestler"},
    {"ts":"2013 - 2016", "description": "Chorleiterin Musikerin Marianna Fuhrich"},
    {"ts":"2017", "description": "Chorleiter Prof. Dr. Rolf Braun"}
    
]


function App(props) {  

    return (
        <div className="component-view animate" data-animate="blendin 3s">
        
        <div className="chronic-container" >
           
                    {
                        chronik.map(item=>(
                            <div className="chronic-content" >
                                                        
                                <div className="chronic-ts text-bold " >
                                    {item.ts}
                                </div>
                                        
                                <div className="chronic-description "> 
                                    {item.description}
                                </div>
                            
                            </div>
                        ))
                    }

</div> 
        </div>
    );
}
    
    export default App;